import React from 'react';

const InvalidRoute = () => {
  return (
    <div>
      <h1>Resource not found!</h1>
    </div>
  );
};
export default InvalidRoute;
